export const messages = {
    "shared-link.footer.link.install": "Experimente o {brandName} gratuitamente",
    "shared-link.footer.link.mobile": "{brandName} para Dispositivos móveis",
    "shared-link.footer.link.android": "Android",
    "shared-link.footer.link.ios": "iOS",
    "shared-link.password-dialog-box.title": "Dados protegidos",
    "shared-link.password-dialog-box.message": "Especifique a palavra-passe para aceder aos dados partilhados",
    "shared-link.password-dialog-box.hint.password": "Palavra-passe",
    "shared-link.password-dialog-box.message.invalid-password": "A palavra-passe está incorreta",
    "shared-link.form.button.open": "Abrir",
    "shared-link.page-not-found.title": "Página não encontrada",
    "shared-link.page-not-found.message.main": "A página que procura não foi encontrada.",
    "shared-link.page-not-found.message.description": "A ligação pode estar desatualizada ou o endereço pode estar incorreto.",
    "shared-link.page-not-found.message.error": "Código de erro: 404",
    "shared-link.restore-file.label.size": "Tamanho",
    "shared-link.restore-file.button.restore": "Transferir",
    "shared-link.links-table.column.name": "Nome",
    "shared-link.links-table.column.size": "Tamanho",
    "shared-link.links-table.action.restore": "Transferir",
    "shared-link.links-table.action.restore-all": "Transferir tudo",
    "shared-link.side-bar.selected.title:plural": "{count} itens selecionados | {count} item selecionado | {count} itens selecionados",
    "shared-link.links-table.label.size": "Tamanho",
    "shared-link.links-table.message.empty-folder": "Esta pasta está vazia"
};
